import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { User } from '../../models/user.model';
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service';
import { UserDataService } from '../../admin/user/user-data.service'; 

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('new_password') newpasswordInput: ElementRef;
  @ViewChild('confirm_password') confirmpasswordInput: ElementRef;

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public user:User;
  public id
  public newpassword
  public confirmpassword
  public showNewPassword: boolean = false;
  public showConfirmPassword: boolean = false;

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private userService: UserDataService) {}

  ngOnInit(): void {

    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User; 
		if ((this.loggedUser != null) && (this.loggedUser != undefined)) {

        this.id = this.loggedUser.UserID

		} else { 
			this.router.navigateByUrl('');
    }
    
    this.iSForm = this.formBuilder.group({
      name: new FormControl(null),
      newpassword: new FormControl(null),
      confirmpassword: new FormControl(null),
    } ); 

  }

  public setData(data: any) {
    this.alertService.clear()
    this.user  = data 
    if (this.user != null && this.user != undefined){
      localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(this.user));
      this.id = data.UserID
		} 
    this.id = data.UserID
  }

  intializeUserDetails()
  {
    this.newpasswordInput.nativeElement.value = ""
    this.confirmpasswordInput.nativeElement.value = ""  
  }

  cancelBtnClickEvent(){
    this.intializeUserDetails()
  }
  

  // exitBtnClickEvent(){ 
  //   this.router.navigateByUrl('landing'); 
  // }

  validateUser():boolean
  { 
        if ((this.newpasswordInput.nativeElement.value == ""  || 
        this.newpasswordInput.nativeElement.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Password')
          return false
        }     

        if ((this.confirmpasswordInput.nativeElement.value == ""  || 
        this.confirmpasswordInput.nativeElement.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Password')
          return false
        }

        if (this.newpasswordInput.nativeElement.value != this.confirmpasswordInput.nativeElement.value)
        { 
          this.alertService.clear()
          this.alertService.error('Password does not match')
          return false
        }
    return true
  }

  saveBtnClickEvent(){
    if (this.validateUser()){
      this.user = new User()
      this.user.UserID =  this.id
      this.user.Password = this.confirmpasswordInput.nativeElement.value
      this.userService.savePassword(this.user, this.loggedUser).subscribe(data =>
      {
        this.alertService.clear()
        this.setData(data)
        this.intializeUserDetails()
        this.alertService.success('Successfully updated the password')
        localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(data));
      },
      error => { 
        this.alertService.clear()
        this.alertService.error('Error occured while saving data')
          
      });
    }  
  }
}
